import { render, staticRenderFns } from "./password.vue?vue&type=template&id=4140862a&scoped=true"
import script from "./password.vue?vue&type=script&lang=ts"
export * from "./password.vue?vue&type=script&lang=ts"
import style0 from "./password.vue?vue&type=style&index=0&id=4140862a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4140862a",
  null
  
)

export default component.exports